export default "__VITE_ASSET__DsXRj8EP__"